interface CanvasPanelVisibility {
  /** `undefined` solange die Route noch kein Projekt aufgelöst hat. */
  projectId: string | undefined
  /** Listen-Modus (schmales Listen-Fenster). */
  isCompactMode: boolean
  /** Stapel-Modus (Kartenstapel statt Liste). */
  isStackMode: boolean
}

/**
 * Ob das `ProjectCanvasPanel` gerendert wird.
 *
 * Der Projekt-Canvas gehört ausschließlich zur vollen **Aufgabenliste**. Im
 * **Listen-Modus** und im **Stapel-Modus** gibt es ihn nicht: dort reicht der
 * Platz nicht, und die geschlossene Werkzeug-Pille allein belegte bereits über
 * 60px Breite — also genau dort, wo am wenigsten übrig ist. Siehe CONTEXT.md,
 * Abschnitt „Projekt-Canvas".
 *
 * **Der Empty-State-Teaser sperrt NICHT mehr.** Er tat es, solange er
 * Aufgabenbrett und Canvas-Einstieg gemeinsam ersetzte. Seit das **Drag
 * Handle** auch aus dem leeren Projekt heraus an der Kante liegt (ADR 0010),
 * muss das Panel dort gerendert werden — nur ohne Pille. Das entscheidet
 * `showToolbar` am Panel, nicht diese Funktion.
 *
 * Die drei Gründe sperren unabhängig voneinander; einer genügt.
 */
export function shouldRenderCanvasPanel({
  projectId,
  isCompactMode,
  isStackMode,
}: CanvasPanelVisibility): boolean {
  return Boolean(projectId) && !isCompactMode && !isStackMode
}
